import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { reactIcons } from "../../utils/icons";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { getAuthReq, postAuthReq, putReq } from "../../utils/apiHandlers";
import toast from "react-hot-toast";
import NotificationBar from "../NotificationBar";
import InfoModal from "../modals/InfoModal";
import moment from "moment/moment";
import { setNotificationUpdate } from "../../redux/Slice/notificationSlice";
import NotificationPanel from "../NotificationPanel";
import axios from "axios";

const Header = ({ toggleSidebar, isVerify }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [NotificationData, setNotificationData] = useState();
  const { userData } = useSelector((state) => state?.user || {});
  const [showNotification, setShownotification] = useState(
    Boolean(Cookies.get(`NotificationShow`)),
  );
  const notificationContainerRef = useRef(null);
  const notificationBellRef = useRef(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notificationAll, setNotificationAll] = useState([]);
  const groupedNotifications = {};
  const dispatch = useDispatch();
  const notificationUpdate = useSelector((state) => state.notification.update);
  const [openInfo, setOpenInfo] = useState(false);
  const currentPath = window.location.pathname;
  const getToken =
    sessionStorage.getItem("referredAs") == "User"
      ? Cookies.get("accessToken")
      : Cookies.get("pfaccessToken");
  const token = useSelector((state) => state.user.token);
  const localFCMToken = token !== localStorage.getItem("fcmToken") || "";
  const [messages, setMessages] = useState([]);
  const [update, setUpdate] = useState(false);
  const [currentMessages, setCurrentMessages] = useState([]);
  const getNotification = async () => {
    try {
      const res = await getAuthReq(
        "/notification/all-active-alert-notification",
      );
      const { data, status } = res;
      if (status) {
        const grouped = data.reduce(
          (acc, item) => {
            if (item.display === "BeforeLogin") {
              acc.BeforeLogin.push(item);
            } else if (item.display === "AfterLogin") {
              acc.AfterLogin.push(item);
            }
            return acc;
          },
          { BeforeLogin: [], AfterLogin: [] },
        );
        setNotificationData(grouped);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    setIsNotificationOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (getToken && notificationUpdate) {
      getOldNotification();
      dispatch(setNotificationUpdate(false));
    }
  }, [notificationUpdate]);

  useEffect(() => {
    if (getToken && userData?.id) {
      getOldNotification();
    }
  }, [getToken, update, userData?.id]);

  const setFirebaseToken = async () => {
    const response = await postAuthReq("/notification/save-token", {
      token: token,
      userId: userData?.id,
    });
    if (!response?.status) {
      localStorage.removeItem("fcmToken");
    }
  };

  useEffect(() => {
    if (getToken && token && localFCMToken) {
      localStorage.setItem("fcmToken", token);
      setFirebaseToken();
    }
  }, [token, getToken]);

  const getOldNotification = useCallback(async () => {
    try {
      const res = await getAuthReq(
        `/notification/get-user-notifications/${userData?.id}`,
      );

      if (res.status) {
        setMessages(res?.data);
        setUpdate(false);
        setNotificationAll(res?.data || []);
      } else {
        toast.error(res.error.message, { toastId: 149 });
      }
    } catch (error) {
      console.error("Error sending wallet address:", error);
    }
  }, [userData?.id, setMessages, setUpdate, setNotificationAll]);

  notificationAll.forEach((item) => {
    const date = moment(item.createdAt);
    const today = moment();
    const yesterday = moment().subtract(1, "days");
    let groupKey = "";
    if (date.isSame(today, "day")) {
      groupKey = "Today";
    } else if (date.isSame(yesterday, "day")) {
      groupKey = "Yesterday";
    } else {
      groupKey = date.format("MMMM D, YYYY");
    }
    if (!groupedNotifications[groupKey]) {
      groupedNotifications[groupKey] = [];
    }

    groupedNotifications[groupKey].push(item);
  });

  useEffect(() => {
    let messageId;
    if (isNotificationOpen && currentMessages.length > 0) {
      const data = {
        ids: messages
          .filter((item) => !item.read)
          .map((item) => item.id || item.notificationId),
      };
      messageId = setTimeout(async () => {
        try {
          const response = await putReq(
            "/notification/change-seen-status",
            data,
          );
          if (response) {
            setCurrentMessages([]);
            getOldNotification();
          }
        } catch (error) {
          toast.error(error?.message || "Something went wrong");
        }
      }, 3000);
    } else return;
    return () => clearTimeout(messageId);
  }, [currentMessages, isNotificationOpen, messages]);

  useEffect(() => {
    getNotification();
  }, []);

  const handleCookiesForShow = () => {
    Cookies.set("NotificationShow", true);
    setTimeout(() => {
      Cookies.remove("NotificationShow");
      setShownotification(Boolean(Cookies.get(`NotificationShow`)));
    }, 1800000);
    setShownotification(Boolean(Cookies.get(`NotificationShow`)));
  };

  useEffect(() => {
    if (messages) {
      const unreadMessage = messages.filter((item) => !item.read);
      setCurrentMessages(unreadMessage);
    }
  }, [messages]);

  return (
    <>
      <NotificationBar
        showNotification={showNotification}
        getToken={getToken}
        NotificationData={NotificationData}
        currentPath={currentPath}
        handleCookiesForShow={handleCookiesForShow}
        reactIcons={reactIcons}
      />
      <div className="h-[80px] w-full z-[9999] bg-black border-b border-[#FFE3E3]">
        <div className="flex lg:items-center justify-between gap-3 cursor-pointer px-3 py-3">
          <div
            onClick={() => {
              const cookeiData =
                sessionStorage.getItem("referredAs") == "User"
                  ? Cookies.get("accessToken")
                  : Cookies.get("pfaccessToken");
              if (cookeiData && !isVerify) {
                navigate("/portal/kyc");
              } else if (cookeiData) {
                navigate("/portal/dashboard");
              } else {
                navigate("/portal");
              }
            }}
            className="flex items-center gap-2"
          >
            <div>
              <img
                loading="lazy"
                src="/images/logo/main.png"
                alt="logo"
                className="w-[50px] md:w-[55px]"
              />
            </div>

            <div>
              <img
                loading="lazy"
                src="/images/logo/sad.png"
                alt="logo"
                className="w-[160px] md:w-[180px]"
              />
              <p className="text-[7px] md:text-[8px] text-white mt-1  text-center">
                YOUR PATH TO A DECENTRALIZED FUTURE
              </p>
            </div>
          </div>

          {getToken && (
            <div className="hidden lg:flex gap-1">
              <button
                type="button"
                onClick={() => setOpenInfo(true)}
                className="text-white py-2 flex  items-center justify-center px-2 bg-gradient-red rounded-md gap-1 font-normal border border-[#EE0000]  md:w-[195px]"
              >
                <span className="text-24">{reactIcons?.support}</span>{" "}
                <span className="text-[15px]">Customer Support</span>
              </button>
              <button
                type="button"
                ref={notificationBellRef}
                onClick={() => {
                  setIsNotificationOpen((prev) => !prev);
                }}
                className=" text-white flex px-3 mt-2 relative text-[25px]  cursor-pointer"
              >
                {reactIcons.notificationBold}
                {currentMessages.length > 0 && (
                  <span
                    className={`${
                      currentMessages.length > 99
                        ? "w-[18px] h-[18px]"
                        : "w-4 h-4"
                    } absolute top-[-6px] right-2  flex items-center justify-center text-10 font-bold  bg-red-500 rounded-full text-white`}
                  >
                    {currentMessages.length > 99
                      ? "99+"
                      : currentMessages.length}
                  </span>
                )}
              </button>
              <div
                className="hidden lg:flex items-center"
                onClick={() => navigate("/portal/profile")}
              >
                <span className="bg-white p-2 rounded-full mr-2">
                  {reactIcons.user}
                </span>
                <div>
                  <p className="text-white capitalize mr-2 font-semibold">
                    {userData?.firstname + " " + userData?.lastname ||
                      "N/A"}{" "}
                  </p>
                  <p className="text-red-500 mr-2 text-12 font-semibold">
                    {userData?.meta?.referredAs == "PowerFranchise" &&
                    !userData?.isClubUser
                      ? "Power Franchise"
                      : userData?.meta?.commissionPercentage >= 10 &&
                          userData?.meta?.commissionPercentage <= 14 &&
                          !userData?.isClubUser
                        ? "Spartans" //Distributor
                        : userData?.meta?.commissionPercentage >= 15 &&
                            userData?.meta?.commissionPercentage <= 19 &&
                            !userData?.isClubUser
                          ? "Spider" //Sub Franchise
                          : userData?.meta?.commissionPercentage >= 20 &&
                              !userData?.isClubUser
                            ? "Avengers" //Franchise
                            : userData?.isClubUser &&
                                userData?.currentClubLevel == 1
                              ? "Warriors"
                              : userData?.isClubUser &&
                                  userData?.currentClubLevel == 2
                                ? "Legends"
                                : userData?.currentClubLevel == 3
                                  ? "Super Legend"
                                  : ""}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="pr-1 flex gap-2 lg:hidden">
            {getToken && (
              <button
                onClick={() => setOpenInfo(true)}
                className="w-[38px] h-[38px] flex-center mt-1  text-white bg-common rounded-full text-3xl"
              >
                {reactIcons.support}
              </button>
            )}

            {getToken && (
              <button
                type="button"
                onClick={() => {
                  setIsNotificationOpen((prev) => !prev);
                }}
                className="w-[38px] h-[38px] flex-center mt-1 relative  text-white bg-common rounded-full text-2xl"
              >
                {reactIcons.notificationBold}
                {currentMessages.length > 0 && (
                  <span
                    className={`${
                      currentMessages.length > 99
                        ? "w-[18px] h-[18px]"
                        : "w-4 h-4"
                    } absolute top-[4px] right-[4px]  flex items-center justify-center text-10 font-bold  bg-red-500 rounded-full text-white`}
                  >
                    {currentMessages.length > 99
                      ? "99+"
                      : currentMessages.length}
                  </span>
                )}
              </button>
            )}
            <button
              onClick={toggleSidebar}
              className="w-[38px] h-[38px] flex-center mt-1 text-white bg-common rounded-full text-3xl"
            >
              {reactIcons.toggle}
            </button>
          </div>
        </div>
      </div>
      {
        <InfoModal
          open={openInfo}
          setOpen={setOpenInfo}
          message={
            "NOTE : Please ensure you provide your registered email address, as the support system will not be able to assist you without it."
          }
          type={"two"}
        />
      }

      <NotificationPanel
        ref={notificationContainerRef}
        groupedNotifications={groupedNotifications}
        isNotificationOpen={isNotificationOpen}
      />
    </>
  );
};
export default Header;
